module.exports = __webpack_public_path__ + "static/img-iphone-unit-cost-zones.63673372.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-iphone-unit-cost-zones.png
// module id = 247
// module chunks = 143588238614448 277043050311175